import axios from "../config/axios"
import axiosKb from "../config/axios-kb"


export const OrganizationRepository = {
  getAll: () => {
    return axios.get(`/api/organization/all`);
  },
  getPaged: (page = 0, size = 10) => {
    return axios.get(`/api/organization`, {params: {page, size}});
  },
  getMyOrganizations: () => {
    return axios.get(`/api/organization/my`);
  },
  getById: (id) => {
    return axios.get(`/api/organization/${id}`);
  },
  delete: (id) => {
    return axios.delete(`/api/organization/${id}`)
  },
  create: (organization) => {
    return axios.post('/api/organization', organization)
  },
  edit: (id, organization) => {
    return axios.put(`/api/organization/${id}`, organization)
  },
  addMember: (id, member) => {
    return axios.post(`/api/organization/${id}/members`, {member})
  },
  removeMember: (id, memberId) => {
    return axios.delete(`/api/organization/${id}/members/${memberId}`)
  },
  // Knowledge-base endpoints, not part of the organization API
  getEntities: (organizationId) => axiosKb.get(`/api/organization/${organizationId}/entities`),
  getRelations: (organizationId) => axiosKb.get(`/api/organization/${organizationId}/relations`),
}
